module.exports = __webpack_public_path__ + "static/P2101507-264cd01557ff1e3b2e2ef28fa1479caf.jpg";